import styled from "styled-components";
import LOGO_WHITE_SVG from "assets/images/logo_white.svg";
import USER_SVG from "assets/images/user.svg";
import useFirebaseAuth from "shared/hooks/useFirebaseAuth";
import { useNavigate } from "react-router-dom";

interface HeaderProp{
    name:string,
    link:string
}
const Header = ({name, link}:HeaderProp) => {
    const {logout} = useFirebaseAuth();
    const navigate = useNavigate();
    return(
        <Container>
            <Logo src={LOGO_WHITE_SVG} alt="toss english white" onClick={() => navigate(link)}/>
            <User>
                <UserLogo src={USER_SVG} alt="user svg"/>
                <UserName >{name}</UserName>
                <LogoutButton type="button" onClick={logout}>로그아웃</LogoutButton>
            </User>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    background: #DF0000;
    box-shadow: 0 1px 0 rgba(15, 23, 42, 0.08);
    padding: 0 32px;
    z-index: 10;
    flex-shrink: 0;
`

const Logo = styled.img`
    width: 168px;
    cursor: pointer;
`
const User = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`
const UserLogo = styled.img`
    width: 16px;
`
const UserName = styled.span`
    color: #FFF;
    font-size: 14px;
    font-weight: 600;
`

const LogoutButton = styled.button`
    appearance: none;
    color: #FFF;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 999px;
    padding: 6px 12px;

    &:hover {
        background: rgba(255, 255, 255, 0.12);
    }
`

export default Header;
